import { IconsEnum } from '@enums/icons.enum';

import { DsIconFontSet } from '@design-system/ds-icon/types/ds-icon-font-set.type';

/**
 * Default Material Symbols font set used by design-system icon rendering.
 */
export const DS_ICON_DEFAULT_FONT_SET: DsIconFontSet = 'material-symbols-rounded';

/**
 * Registered SVG icon names that `ds-icon` renders through `svgIcon`.
 */
export const DS_REGISTERED_ICON_NAMES: ReadonlySet<string> = new Set<string>(Object.values(IconsEnum));
